import React, { Fragment } from "react";
// import { Footerdark, PageLayout } from "../../../Constant";
import { Footerdark,PageLayout } from "../../../Constant";
import PaymentTable from "./PaymentTable";

const Paymentlist = () => {
    return (
        <Fragment>
            <PaymentTable mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default Paymentlist;